import React from "react";
import "../styles/Hero.css";

export default function Hero() {
    return (
        <header className="hero">
            <h1>100 Days of CSS</h1>
        </header>
    )
}